export default __webpack_public_path__ + "static/media/affiche2019.5923113a.png";